// Resolves this app's own base URL for building links (email confirmation redirects, etc.).
//
// NOTE:
// - In Vite runtime, `import.meta.env` exists, but Jest (CJS) cannot parse
//   `import.meta` at all — even guarded with `(import.meta as any)`, it's a parse
//   error, not a runtime one. Isolated into its own module (mapped to a Jest mock
//   in jest.config.js) so callers stay testable, mirroring the existing
//   `utils/encryption` mock pattern used for the same reason.
export function getAppUrl(): string {
  const origin = typeof window !== 'undefined' ? window.location.origin.replace(/\/$/, '') : '';
  if (origin) return origin;

  const viteEnvUrl = (import.meta as any).env?.VITE_APP_URL as string | undefined;
  if (viteEnvUrl) return viteEnvUrl.replace(/\/$/, '');

  const processEnvUrl = typeof process !== 'undefined' ? process.env.VITE_APP_URL : undefined;
  if (processEnvUrl) return processEnvUrl.replace(/\/$/, '');

  return 'http://localhost:3000';
}
